export const firebaseConfig = {
  apiKey: "AIzaSyCIbpeFb79b49q09gglFRlUAOgwGkbgkQ8",
  authDomain: "gradepad-improved.firebaseapp.com",
  projectId: "gradepad-improved",
  storageBucket: "gradepad-improved.firebasestorage.app",
  messagingSenderId: "223375674663",
  appId: "1:223375674663:web:6a2c54d972034e1c21ed02",
  measurementId: "G-7T6TTG6XQL"
};
